import { enumOf, useTableParams, type FieldSpec } from "@/hooks/useTableParams";

/**
 * `all` is these toolbars' no-filter sentinel (Radix Select forbids an
 * empty-string value), so it belongs in the allowed set.
 */
const withAll = (values: readonly string[]) => enumOf(["all", ...values]);

export const PAYROLL_LIST_STATUS_VALUES = [
  "PAID",
  "PENDING",
  "HOLD",
  "EXCLUDED",
];

const DEFAULTS = { branch: "all", department: "all", status: "all" };

/** `"all"` or a junk value → undefined; anything numeric → a number. */
export const toIdParam = (value: string): number | undefined => {
  if (!value || value === "all") return undefined;
  const n = Number(value);
  return Number.isInteger(n) ? n : undefined;
};

/**
 * URL-backed toolbar state shared by the payslips, final-settlements and
 * offboarding-settlements lists — same branch / department / status shape.
 *
 * @param ns Set where more than one of these shares a url.
 */
export const usePayrollListParams = (ns?: string) =>
  useTableParams<typeof DEFAULTS>({
    defaults: DEFAULTS,
    schema: {
      // Ids can't be enumerated up front; `toIdParam` drops anything
      // non-numeric at the call site.
      branch: "string",
      department: "string",
      status: withAll(PAYROLL_LIST_STATUS_VALUES),
    } satisfies Partial<Record<keyof typeof DEFAULTS, FieldSpec>>,
    ns,
  });
